import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'nameChange',
  standalone: true
})
export class NameChangePipe implements PipeTransform {

  transform(value: string): string {
    if (!value || typeof value !== 'string') return '';
    const replacements: Record<string, string> = {
      'Number Loans': 'Number of Loans',
      'Number Facilities': 'Number of Facilities',
      'Number Contracts': 'Number of Contracts',
      'Avg Amount': 'Average Amount',
      'Avg Original Termin': 'Average Original Term',
      'Avg Rate': 'Average Rate',
      'Delinquency 30': 'Delinquent Portfolio (30+)',
      'Delinquency 90': 'Delinquent Portfolio (90+)',
      'Total Portfolio': '% of Total Portfolio'
    };
    return replacements[value.trim()] ?? value;
  }
}
